import { atom } from 'jotai'

export const areLpBalancesLoadedAtom = atom(false)
